import { render } from "./HomeItsOurOfferingsComp.vue?vue&type=template&id=2302bd9c&scoped=true"
import script from "./HomeItsOurOfferingsComp.vue?vue&type=script&lang=js"
export * from "./HomeItsOurOfferingsComp.vue?vue&type=script&lang=js"

import "./HomeItsOurOfferingsComp.vue?vue&type=style&index=0&id=2302bd9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2302bd9c"]])

export default __exports__